export const NEW_USER_STEPS = {
  INTRO: 'INTRO',
  FORM: 'FORM',
  COMPLETED: 'COMPLETED',
};
